import _ from 'lodash'
import i18n from 'scoreboard/components/i18n'

var RelativeOptions = function(opts = {}) {
	this.start = _.defaultTo(opts.start, -24)
	this.end = Math.max(_.defaultTo(opts.end, 24), this.start)
	this.calendar = opts.calendar
}

RelativeOptions.prototype.generate = function() {
	var result = []
	for (var i=this.start; i<=this.end; i++) {
		result.push({id: i, label: this.label(i, this.calendar)})
	}
	return result
}

RelativeOptions.prototype.label = function(distance, calendar) {
	// If we have a calendar, and if we have Mr.P keys for that calendar, use
	// those, otherwise, fall back on generic "period(s)" language
	const getMsgOrFallbackToGeneric = (baseKey, args = []) => {
		const keySuffix = calendar ? `.${calendar.type}` : ''
		const specificKey = `${baseKey}${keySuffix}`
		const specificMsg = i18n.get(specificKey, ...args)
		if (specificMsg !== specificKey) {
			return specificMsg
		} else {
			return i18n.get(baseKey, ...args)
		}
	}

	if (distance > 1) {
		return getMsgOrFallbackToGeneric('report.customReport.periodsFromNow',
			[distance])
	} else if (distance == 1) {
		return getMsgOrFallbackToGeneric('report.customReport.nextPeriod')
	} else if (distance == 0) {
		return getMsgOrFallbackToGeneric('report.customReport.currentPeriod')
	} else if (distance == -1) {
		return getMsgOrFallbackToGeneric('report.customReport.previousPeriod')
	} else {
		return getMsgOrFallbackToGeneric('report.customReport.periodsAgo',
			[Math.abs(distance)])
	}
}

RelativeOptions.label = RelativeOptions.prototype.label

export default RelativeOptions
RelativeOptions.__filename__ = 'components/relative-options.js'
